
import React, { useState, useEffect, useRef } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { CiHeart } from "react-icons/ci";
import { LiaShoppingBagSolid } from "react-icons/lia";
import { FiSearch } from "react-icons/fi";
import { FaUserCircle } from "react-icons/fa";
import { BsBoxSeam } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
import Login from "../Login/Login";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";



export default function Navbar() {
  const accessToken = sessionStorage.getItem("accessToken");
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [navbarColor, setNavbarColor] = useState("#000");
  const [hoverColor, setHoverColor] = useState("transparent");
  const [navbarTextColor, setnavbarTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const app_logo = sessionStorage.getItem("appLogo");
  const appName = sessionStorage.getItem("appName") || "Grobiz";
  const [logoAvailable, setLogoAvailable] = useState(false);
  const fullLogoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const profileRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const navigate = useNavigate();
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef = useRef(null);
  const [categories, setCategories] = useState([]);
  // Predefined color palette for categories
  const colorPalette = [
    "#ee5f73", // Original colors
    "#fb56c1",
    "#f26a10",
    "#f2c210",
    "#0db7af",
    "#6b7280",
    "#8b5cf6",
    "#ec4899",
    "#3b82f6",
    "#10b981",
    "#f97316",
    "#8b5cf6",
    "#ef4444",
    "#6366f1",
    "#14b8a6",
    "#f43f5e",
    "#84cc16",
    "#a855f7",
    "#22d3ee",
    "#facc15",
    "#4b5563",
    "#d946ef",
    "#06b6d4",
    "#fb923c",
    "#34d399",
    "#7c3aed",
    "#f59e0b",
    "#6ee7b7",
    "#c026d3",
    "#0ea5e9",
    "#f87171",
    "#2dd4bf",
    "#d8b4fe",
    "#dc2626",
    "#4ade80",
    "#7e22ce",
    "#38bdf8",
  ];
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_main_category_list`,
          {
            admin_auto_id: sessionStorage.getItem("admin_auto_id"),
            app_type_id: sessionStorage.getItem("app_type_id"),
          }
        );
        if (response.data.status === 1) {
          const fetchedCategories = response.data.getmain_categorylist.slice(0, 6); // Limit to 6 categories
          // Map API data to Navbar4 categories structure
          const transformedCategories = fetchedCategories.map(
            (category, index) => ({
              name: category.category_name.toUpperCase(),
              color: colorPalette[Math.floor(Math.random() * colorPalette.length)], // Assign color from palette
              category_auto_id: category.category_auto_id, // Store category ID
              subcategories: category.getmain_subcategorylist.map((subcat) => ({
                name: subcat.sub_category_name,
                sub_category_auto_id: subcat.sub_category_auto_id, // Store subcategory ID
                items: subcat.getmain_subsubcategorylist.map((subsub) => ({
                  name: subsub.sub_category_name,
                  _id: subsub._id || subsub.sub_category_auto_id, // Use _id if available, else sub_category_auto_id
                })),
              })),
            })
          );
          setCategories(transformedCategories);
          // Set the first category as active by default
          if (transformedCategories.length > 0) {
            setActiveCategory(transformedCategories[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);


  useEffect(() => {
    const handleClickOutsideSearch = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideSearch);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSearch);
    };
  }, []);


  const fetchWishlistCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_wishlist_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setWishlistCount(res.data.product_count_data);
      } else {
        setWishlistCount(0);
      }
    } catch (error) {
      setWishlistCount(0);
      console.error("Error fetching wishlist count:", error);
    }
  };

  useEffect(() => {
    const handleUserDataUpdated = () => {
      if (accessToken) {
        fetchWishlistCount();
        fetchCartCount();
      } else {
        setWishlistCount(0); // reset when not logged in
        setCartCount(0);
      }
    };

    window.addEventListener("wishlist-updated", handleUserDataUpdated);
    window.addEventListener("cart-updated", handleUserDataUpdated);

    // Initial fetch if logged in
    if (accessToken) {
      fetchWishlistCount();
      fetchCartCount();
    }

    return () => {
      window.removeEventListener("wishlist-updated", handleUserDataUpdated);
      window.removeEventListener("cart-updated", handleUserDataUpdated);
    };
  }, [accessToken]);

  const fetchCartCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setCartCount(res.data.product_count_data);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      setCartCount(0);
      console.error("Error fetching cart count:", error);
    }
  };


  const goToCart = () => {
    navigate("/cart");
  };
  const goToWishlist = () => {
    !accessToken
      ? openModal()
      : navigate("/dashboard", { state: { page: "mywishlist" } });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setNavbarColor(parsedStyle.nav_bar_color);
      setnavbarTextColor(parsedStyle.navbar_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setShowSearchBar(parsedStyle.show_search_bar === "Yes");
    }
  }, []);


  useEffect(() => {
    if (app_logo) {
      const fullUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
      const img = new Image();
      img.src = fullUrl;

      img.onload = () => setLogoAvailable(true);
      img.onerror = () => setLogoAvailable(false);
    }
  }, [app_logo]);


  const handleInputChange = async (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (!value.trim()) {
      // Clear results immediately on backspace/empty
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/search_product`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
          customer_auto_id: accessToken || sessionStorage.getItem("admin_auto_id"),
          search: value,
          limit: 15,
          page_number: 1,
        }
      );

      // If input still has value, show results. If not, don't show anything.
      if (response.data.status === 1 && value.trim() !== "") {
        setSuggestions(response.data.get_search_products_lists || []);
        setShowDropdown(true);
      } else {
        setSuggestions([]);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error("Search error:", error);
      setSuggestions([]);
      setShowDropdown(false);
    }
  };


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    if (!hex || typeof hex !== 'string' || !hex.startsWith('#') || hex.length !== 7) {
      return 'rgb(0, 0, 0)'; // Fallback to black if invalid
    }

    const num = parseInt(hex.replace('#', ''), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }


  return (
    <div className={`sticky top-0 z-10 w-full  border-b shadow-md ${font}`}
      style={{ backgroundColor: navbarColor }}>
      <div className="max-w-[1200px] mx-auto flex items-center justify-between px-1 h-20">
        <div className="flex items-center gap-8">
          <a
            className="flex items-center text-xl font-bold no-underline sm:text-2xl"
            href="/"
          >
            {logoAvailable ? (
              <img src={fullLogoUrl} alt="Myntra" className="object-contain w-10 h-8" />
            ) : (
              <span>{appName}</span>
            )}
          </a>

          {categories.map((cat, index) => (
            <div
              key={cat.name}
              onMouseEnter={() => setActiveCategory(cat)}
              onMouseLeave={() => setActiveCategory(null)}
              className="relative"
            >
              <Link
                to={`/maincategory/${cat.category_auto_id}`} className="no-underline cursor-pointer text-inherit ">
                <div className="py-4 text-sm font-semibold cursor-pointer" style={{ color: navbarTextColor !== "" ? "#000000" : navbarTextColor }}>
                  {cat.name}
                </div>
              </Link>
              {activeCategory?.name === cat.name && (
                <div
                  className="absolute left-0 right-0 h-1"
                  style={{ backgroundColor: cat.color, bottom: 0 }}
                ></div>
              )}
            </div>
          ))}
        </div>

        <div className="flex items-center gap-6">
          {showSearchBar && (
            <div className="relative" ref={searchRef}>

              <div className="flex items-center">
                <FiSearch className="absolute ml-2 text-black" />
                <input
                  type="text"
                  placeholder="Search for products, brands and more"
                  className="px-4 py-2 pl-10 text-sm placeholder-black rounded-md w-72 focus:outline-none focus:ring-2 focus:ring-white " style={{ backgroundColor: darkenHexColor(navbarColor, 0.1) }}
                  value={searchQuery}
                  onChange={handleInputChange}
                />
              </div>
              {showDropdown && suggestions.length > 0 && (
                <div className="absolute z-50 mt-1 overflow-y-auto bg-white border rounded-md shadow-lg w-72 top-full max-h-72" >
                  {suggestions.map((product, index) => (
                    <div
                      key={index}
                      className="px-4 py-2 text-sm cursor-pointer text-gray-950 hover:bg-gray-100"
                      onClick={() => navigate(`/product-detail/${product.product_auto_id}`)}

                    >
                      {product.product_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <div ref={profileRef} className="relative text-center">
            <div
              className="cursor-pointer"
              onClick={() => !accessToken
                ? openModal()
                : setShowProfileDropdown(!showProfileDropdown)}
            >
              <AiOutlineUser className="mx-auto text-xl" />
              <span className="text-xs font-extrabold " style={{ color: navbarTextColor !== "" ? "#000000" : navbarTextColor }}>Profile</span>
            </div>

            {/* Red underline when active */}
            <div
              className={`h-[3px] w-full transition-all duration-200 mt-1 ${showProfileDropdown ? "bg-red-500" : "bg-transparent"
                }`}
            ></div>

            {/* Profile dropdown */}
            {showProfileDropdown && (
              <div className="absolute right-0 z-50 mt-2 bg-white border rounded-md shadow-lg top-full w-44" >
                <ul className="pl-0 text-sm text-left " style={{ color: navbarTextColor !== "" ? "#000000" : navbarTextColor }}>

                  <li className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-100 " >
                    <Link
                      to="/dashboard"
                      className="flex items-center gap-2 no-underline text-inherit"
                    >
                      <FaUserCircle className="text-base" />
                      My Profile
                    </Link>
                  </li>
                  <li className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-100 "

                    onClick={() => {
                      navigate("/dashboard", { state: { page: "myorders" } });

                    }}>
                    <BsBoxSeam className="text-base" />
                    Orders
                  </li>
                  <li
                    className="flex items-center gap-2 px-4 py-2 text-red-600 cursor-pointer hover:bg-gray-100 "

                    onClick={() => {
                      sessionStorage.removeItem("accessToken");
                      navigate("/");
                      setTimeout(() => window.location.reload(), 100);
                    }}
                  >
                    <FiLogOut className="text-base" />
                    Logout
                  </li>
                </ul>
              </div>
            )}

          </div>

          <div className="relative mb-1 text-center ">
            <CiHeart className="mx-auto text-xl cursor-pointer" size={22} onClick={goToWishlist} />
            <span className="text-xs font-extrabold text-black">Wishlist</span>
            {wishlistCount > 0 && (
              <span className="absolute -top-1 right-1 bg-red-500 text-white text-[10px] sm:text-xs px-1.5 sm:px-1.5 py-0.5 rounded-full">
                {wishlistCount}
              </span>
            )}
          </div>
          <div className="relative mb-1 text-center ">
            <LiaShoppingBagSolid className="mx-auto text-xl cursor-pointer" size={22} onClick={goToCart} />
            <span className="text-xs font-extrabold text-black">Bag</span>
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1.5 bg-red-500 text-white text-[10px] sm:text-xs px-1.5 sm:px-1.5 py-0.5 rounded-full">
                {cartCount}
              </span>
            )}
          </div>
        </div>
      </div>

      {activeCategory && activeCategory.subcategories.length > 0 && (
        <div
          className="min-w-[1100px] mx-auto px-4 py-4 grid grid-cols-5 gap-6 bg-white max-h-[450px] overflow-y-auto  border-t shadow-md"
          style={{
            top: "74px",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",

          }}
          onMouseEnter={() => setActiveCategory(activeCategory)}
          onMouseLeave={() => setActiveCategory(null)}
        >
          {(() => {
            const columns = [[], [], [], [], []]; // 5 columns
            activeCategory.subcategories.forEach((subcat, i) => {
              columns[i % 5].push(subcat); // Distribute subcategories across columns
            });

            return columns.map((col, colIndex) => (
              <div key={colIndex} className="flex flex-col gap-4">
                {col.map((subcat, i) => (
                  <div
                    key={subcat.sub_category_auto_id + i}
                    className={`p-2 ${colIndex % 2 === 0 ? "bg-white" : "bg-gray-50"} flex flex-col`}

                  >
                    <div className="flex flex-col">
                      <Link
                        to="/productlist"
                        state={{
                          subcategoryName: subcat.name,
                          sub_cat_id: subcat.sub_category_auto_id,
                        }}
                        className="no-underline"
                      >
                        <h4
                          className="text-sm font-bold "
                          style={{ color: activeCategory.color }}
                        >
                          {subcat.name}
                        </h4>
                      </Link>
                      {subcat.items.length > 0 && (
                        <ul className="pl-0 mt-1 space-y-1">
                          {subcat.items.map((item, j) => (
                            <li
                              key={item._id + j}
                              className="text-sm cursor-pointer hover:font-extrabold"
                            >
                              <Link
                                to="/subsubcatproductlist"
                                state={{
                                  subsubcategoryName: item.name,
                                  sub_sub_cat_id: item._id,
                                }}
                                className="no-underline text-inherit"
                                style={{ color: navbarTextColor !== "" ? "#000000" : navbarTextColor }}
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ));
          })()}
        </div>
      )}
      {isOpen && <Login isOpen={isOpen} onClose={closeModal} />}
    </div>
  );
}